export interface IUserAddress {
    id?: number;
    address: string;
    city: string;
    country: number;
    isPrimaryAddress: number;
    postalCode: string;
    state: string;
    user?: number;
}

export class UserAddress implements IUserAddress {
    id?: number;
    address = '';
    city = '';
    country = null;
    isPrimaryAddress = 0;
    postalCode = '';
    state = '';

    constructor(address: Partial<IUserAddress> = {}) {
        Object.assign(this, address);
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/api-response/building/user-address.ts